import React from 'react';

function MyTickets() {
  return (
    <div className="my-tickets">
      <h1>My Tickets</h1>
      {/* Bilet listesi buraya gelecek */}
    </div>
  );
}

export default MyTickets; 